import * as React from 'react';
import { ColumnProps, SorterResult } from 'antd/lib/table';
import { useApiQuery } from 'client/core/network/hooks/useApiQuery';
import { DepositApi } from '../../DepositApi';
import { useState } from 'react';
import { IDeposit } from 'common/schema/Deposit';
import { IDossier } from 'common/schema/Dossier';
import { TableScroll } from 'client/ui/table/TableScroll';
import { IDepositDossiersQueryDto } from 'common/dto/DepositDossiersQueryDto';
import { tableLoaderSpin } from 'client/ui/loader/tableLoaderSpin';
import {
  createColumnFilter,
  FilterInputType,
  getFilter
} from 'client/ui/table/TableColumnFilter';
import { ColumnSortDirections } from 'client/ui/table/TableColumnSort';

export interface TableDepositDossierListProps {
  deposit: IDeposit;
  label?: React.ReactNode;
}

/**
 * Tabella che mostra l'elenco dei fascicoli versati in un versamento.
 * TODO: Gestire errori
 */
export function TableDepositDossierList(props: TableDepositDossierListProps) {
  const { deposit } = props;

  const [query, setQuery] = useState<IDepositDossiersQueryDto>({
    page: 1,
    pageSize: 20
  });

  const { response, loading, error } = useApiQuery(DepositApi.listDossiers, {
    data: {
      id: deposit.id,
      query
    }
  });

  const columns: ColumnProps<IDossier>[] = [
    {
      title: 'UID',
      dataIndex: 'uid',
      width: 80,
      ellipsis: true,
      sorter: true
    },
    {
      title: 'A.O.O.',
      dataIndex: 'areaName',
      width: 160,
      ellipsis: true,
      ...createColumnFilter(FilterInputType.Text)
    },
    // {
    //   title: 'Registro',
    //   dataIndex: 'register'
    // },
    {
      title: 'Codice',
      dataIndex: 'code',
      width: 140,
      ellipsis: true,
      ...createColumnFilter(FilterInputType.Text)
    },
    // {
    //   title: 'Classe',
    //   dataIndex: 'category'
    // },
    {
      title: 'Titolo',
      dataIndex: 'title',
      ellipsis: true,
      ...createColumnFilter(FilterInputType.Text)
    }
  ];

  return (
    <TableScroll
      label={props.label}
      bottomSpace={64}
      loading={tableLoaderSpin(loading || !response)}
      columns={columns}
      dataSource={response?.data.items || []}
      onChange={(pagination, filters, sorter) => {
        const { field, order } = sorter as SorterResult<IDossier>;

        const areaName = getFilter<string>(filters, 'areaName');
        const code = getFilter<string>(filters, 'code');
        const title = getFilter<string>(filters, 'title');

        setQuery({
          ...query,
          areaName,
          code,
          title,
          orderBy: order ? field?.toString() : 'id',
          orderByDirection: order
            ? ColumnSortDirections[order]
            : ColumnSortDirections.descend,
          page: pagination.current || query.page,
          pageSize: pagination.pageSize || query.pageSize
        });
      }}
      pagination={{
        pageSize: query.pageSize,
        current: query.page,
        total: response?.data.meta.total
      }}
    />
  );
}
